import React from 'react';
import { useApp } from '../../../../context/app';
import { Gerenciar } from './Gerenciar';
import { Incluir } from './Incluir';
import { OrdernarPerguntas } from "./OrdernarPerguntas";

export const HabilitarDiagnostico = () => {
    const { renderIncludeScreen, manageItem } = useApp();

    if (renderIncludeScreen && manageItem?.type === 'ordenacao') {
        return <OrdernarPerguntas/>
    }
    return renderIncludeScreen ? ( <Incluir /> ) : ( <Gerenciar /> );
};
